import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./WhatWeOffer.css";
import { FaGlobe, FaMobileAlt, FaShoppingCart, FaLaptopCode, FaArrowRight } from "react-icons/fa";
import { useScrollReveal } from "../../hooks/useScrollReveal";

const services = [
  {
    icon: FaGlobe,
    title: "Sites Web & Landing Pages",
    desc: "Un site vitrine moderne, rapide et adapte mobile pour donner une image professionnelle a votre entreprise.",
    slug: "developpement-web",
    price: "a partir de 150 000 FCFA",
    delay: "7 a 14 jours",
    targets: ["Restaurants", "Salons de beaute", "Artisans", "Freelances"],
  },
  {
    icon: FaLaptopCode,
    title: "Applications Web",
    desc: "Espace client, back-office, gestion de commandes — des applications web sur mesure avec React et Node.js.",
    slug: "applications-web",
    price: "a partir de 400 000 FCFA",
    delay: "3 a 6 semaines",
    targets: ["Startups", "PME", "Plateformes SaaS", "Back-offices"],
  },
  {
    icon: FaMobileAlt,
    title: "Applications Mobiles",
    desc: "iOS et Android depuis un seul code source (React Native). Concu pour les utilisateurs ivoiriens et africains.",
    slug: "applications-mobiles",
    price: "a partir de 500 000 FCFA",
    delay: "4 a 8 semaines",
    targets: ["Livraison", "Reservations", "Marketplaces", "Fintech"],
  },
  {
    icon: FaShoppingCart,
    title: "E-commerce",
    desc: "Boutique en ligne avec paiement Orange Money et Wave integres. Vos clients paient en quelques secondes.",
    slug: "applications-e-commerce",
    price: "a partir de 300 000 FCFA",
    delay: "2 a 4 semaines",
    targets: ["Mode & pret-a-porter", "Cosmetiques", "Alimentation", "Artisanat"],
  },
];

export default function WhatWeOffer() {
  const { pathname } = useLocation();
  useScrollReveal('[data-reveal]');

  return (
    <section className="what-we-offer">
      <h2>Nos services</h2>
      <p className="wwo-intro">
        Des solutions digitales concretes pour les PME, startups et entrepreneurs en Cote d'Ivoire.
      </p>
      <div className="offer-grid">
        {services.map((s, i) => {
          const Icon = s.icon;
          return (
            <Link
              to={`/services/${s.slug}`}
              state={{ from: pathname }}
              key={s.slug}
              className="offer-card-link"
              aria-label={s.title}
              data-reveal
              data-delay={i * 100}
            >
              <div className="offer-card">
                <div className="offer-icon">
                  <Icon size={28} />
                </div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
                <div className="offer-targets">
                  <span className="offer-targets__label">Ideal pour :</span>
                  <div className="offer-targets__chips">
                    {s.targets.map(t => (
                      <span key={t} className="offer-target-chip">{t}</span>
                    ))}
                  </div>
                </div>
                <div className="offer-meta">
                  <span className="offer-price">{s.price}</span>
                  <span className="offer-delay">{s.delay}</span>
                </div>
                <div className="offer-see-more">
                  Voir le detail <FaArrowRight size={12} />
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
